import React, {VoidFunctionComponent} from 'react';
import ReactMarkdown from 'react-markdown';
import {useIntl} from 'react-intl';

import StaticTextScreen from '../static-text-screen/static-text-screen';

const PrivacyScreen: VoidFunctionComponent<Record<string, unknown>> = () => {
  const intl = useIntl();

  return (
    <StaticTextScreen headlineId="privacy.headline">
      <ReactMarkdown children={intl.formatMessage({id: 'privacy.text'})} />
    </StaticTextScreen>
  );
};
export default PrivacyScreen;
